import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Box from "@mui/material/Box";
import { Tab, Theme, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

const ScrollableTabs = () => {
  const { t } = useTranslation();
  const [activeStep, setActiveStep] = React.useState(0);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const steps = [
    { label: t("talents.tabs.talentPool"), count: 24, additional: "+2" },
    { label: t("talents.tabs.applied"), count: 57, additional: "+5" },
    { label: t("talents.tabs.hiringManagerReview"), count: 42, additional: "" },
    { label: t("talents.tabs.interviewing"), count: 23, additional: "" },
    { label: t("talents.tabs.referenceCheck"), count: 2, additional: "" },
    { label: t("talents.tabs.offer"), count: 1, additional: "" },
    { label: t("talents.tabs.hired"), count: 1, additional: "" },
    { label: t("talents.tabs.archive"), count: 43, additional: "" },
  ];

  const handleStepChange = (event: React.SyntheticEvent, newStep: number) => {
    setActiveStep(newStep);
  };

  return (
    <Box sx={sxProps.container}>
      <Tabs
        value={activeStep}
        onChange={handleStepChange}
        variant={!isSmallScreen ? "fullWidth" : "scrollable"}
        aria-label="scrollable prevent tabs example"
        sx={sxProps.tabs}
      >
        {steps.map((step, index) => (
          <Tab
            key={step.label}
            value={index}
            label={
              <Box sx={sxProps.tabContent}>
                <Typography variant="h6">{step.count}</Typography>
                <Typography variant="caption">{step.label}</Typography>
              </Box>
            }
            sx={[
              sxProps.stepperItem,
              index === activeStep ? sxProps.currentStep : {},
              index === 0 ? sxProps.firstStep : {},
              index === steps.length - 1 ? sxProps.lastStep : {},
            ]}
          />
        ))}
      </Tabs>
    </Box>
  );
};

export default ScrollableTabs;

const sxProps = {
  container: {
    mt: "4px",
    width: "100%",
    bgcolor: "#8d99ff",
    position: "relative",
    "&::before": {
      position: "absolute",
      top: "50%",
      left: 0,
      height: "80px",
      content: '""',
      width: "calc(100%)",
      background:
        "linear-gradient(90deg, #8d99ff 0%, #8d99ff 73%, #98D2C3 100%, #98D2C3 100%)",
      transform: "translateY(-50%)",
      zIndex: 1,
    },
  },
  tabs: {
    display: "flex",
    padding: 0,
    listStyle: "none",
    position: "relative",
    zIndex: 2,
    ".MuiTab-root:nth-child(2), .MuiTab-root:nth-last-child(2), .MuiTab-root:nth-last-child(3) ":
      {
        maxWidth: "10%",
        minWidth: "110px",
      },
    ".MuiTabs-indicator": {
      display: "none",
    },
  },
  tabContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    whiteSpace: "nowrap",
  },
  stepperItem: {
    flex: 1,
    padding: "10px 20px 10px 40px",
    background: "white",
    margin: "0 0 0 calc(-30px + 1px)",
    minWidth: "210px",
    clipPath:
      "polygon(30px 50%, 0% 0%, calc(100% - 30px) 0%, 100% 50%, calc(100% - 30px) 100%, 0% 100%)",

    "&:hover": {
      background: "#bec4fc",
      color: "white",
    },
  },
  currentStep: {
    background: "#8d99ff",
    fontWeight: "bold",
    color: "white !important",
    borderTop: "1px solid #8d99ff",
    borderBottom: "1px solid #8d99ff",
  },
  completeStep: {
    background: "white",
    borderTop: "1px solid #8d99ff",
    borderBottom: "1px solid #8d99ff",
    "&:hover": {
      background: "#8d99ff",
      color: "white",
    },
  },
  firstStep: {
    clipPath:
      "polygon(0% 0%, calc(100% - 30px) 0%, 100% 50%, calc(100% - 30px) 100%, 0% 100%)",
    borderTopLeftRadius: "5px",
    borderBottomLeftRadius: "5px",
    borderLeft: "1px solid #8d99ff",
    background: "#98D2C3",
    color: "white",
  },
  lastStep: {
    clipPath: "polygon(30px 50%, 0% 0%, 100% 0%, 100% 100%, 0% 100%)",
    borderTopRightRadius: "5px",
    borderBottomRightRadius: "5px",
    borderRight: "1px solid lightgrey",
    maxWidth: "10%",
    minWidth: "110px",
    background: (theme: Theme) => theme.palette.grey[400],
    color: "black",
  },
};
